import person from "../components/images/person.png";

export const aboutUsDummyData = [
  {
    img: person,
    alt: "some text",
    position: "Project menager",
    name: "Thomas"
  },
  {
    img: person,
    alt: "some text",
    position: "Project menager",
    name: "Thomas"
  },
  {
    img: person,
    alt: "some text",
    position: "Project menager",
    name: "Thomas"
  },
  {
    img: person,
    alt: "some text",
    position: "Project menager",
    name: "Thomas"
  }
];
